import axios from "axios";
import { apiBaseUrl } from "@/lib/env";

const TOKEN_KEY = "console_auth_token";

const consoleApi = axios.create({
  baseURL: apiBaseUrl(),
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export function getConsoleToken() {
  return sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY);
}

export function setConsoleToken(token, remember = true) {
  clearConsoleToken();
  const store = remember ? localStorage : sessionStorage;
  store.setItem(TOKEN_KEY, token);
  consoleApi.defaults.headers.common.Authorization = `Bearer ${token}`;
}

export function clearConsoleToken() {
  localStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(TOKEN_KEY);
  delete consoleApi.defaults.headers.common.Authorization;
}

const existing = getConsoleToken();
if (existing) {
  consoleApi.defaults.headers.common.Authorization = `Bearer ${existing}`;
}

consoleApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !error.config?.url?.includes("/console/login")) {
      clearConsoleToken();
      const path = window.location.pathname || "";
      if (!path.includes("/console/login")) {
        const base = import.meta.env.BASE_URL || "/";
        const prefix = base.endsWith("/") ? base.slice(0, -1) : base;
        window.location.assign(`${prefix}/console/login`);
      }
    }
    return Promise.reject(error);
  },
);

export default consoleApi;
